import cssModule from "@vercel/turbopack-next/internal/font/local/cssmodule.module.css?{%22path%22:%22custom-fonts.ts%22,%22import%22:%22%22,%22arguments%22:[{%22src%22:[{%22path%22:%22./fonts/FuturaCyrillicBook.woff2%22,%22weight%22:%22350%22,%22style%22:%22normal%22},{%22path%22:%22./fonts/FuturaCyrillicMedium.woff2%22,%22weight%22:%22500%22,%22style%22:%22bold%22}],%22variable%22:%22--custom-font-futura-pt%22,%22preload%22:false}],%22variableName%22:%22futuraPT%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'futuraPT', 'futuraPT Fallback'",
        
    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
